import "core-js/modules/es.array.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3734dc0f"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "primary"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "secondary"
}, " 下载速度 ", -1));
const _hoisted_4 = {
  class: "primary"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "secondary"
}, " 剩余流量 ", -1));
const _hoisted_6 = {
  class: "primary"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "secondary"
}, " 金豆数量 ", -1));
import BirdAwake from '@shared/assets/img/bird-awake.png';
import BirdSleep from '@shared/assets/img/bird-sleep.png';
import BirdGrowing from '@shared/assets/img/bird-growing.png';
import { formatSize } from '@shared/utils/bytes';
import { computed, ref, watch } from 'vue';
import { openPopGoldBeanInfo, openPopHighSpeedFlowPurchase } from '@remote/utils/dialog';
import { useDeviceStore } from '@remote/store/device';
import { onMounted } from 'vue';
import { useFlowStat } from '@remote/composable/stat';
import { store } from '@remote/store';
import { useGoldBeanStatStatus } from '@remote/composable/floating-bird';
import { useGoldBeanStat } from '@shared/composable/gold-beans';
import { stat } from '@remote/utils/stat';
import { useUserStore } from '@remote/store/user';
const DRAG_MOVE_THRESHOLD = 3;
const MAX_DIFF_Y = 56;
export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingBird',
  props: {
    runningTaskList: {
      type: Array,
      required: true
    },
    pausedTaskList: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const deviceStore = useDeviceStore();
    const isManualClickBird = ref(false);
    const haveTaskRunning = computed(() => {
      return props.runningTaskList.length > 0;
    });
    const haveTaskPaused = computed(() => {
      return props.pausedTaskList.length > 0;
    });
    const isSpeedShow = computed(() => {
      return isManualClickBird.value || haveTaskRunning.value; // || haveTaskPaused.value
    });

    const totalSpeed = computed(() => {
      if (haveTaskRunning.value) {
        const totalSpeedInByte = props.runningTaskList.reduce((acc, cur) => {
          var _cur$params$speed, _cur$params;
          return acc + Number((_cur$params$speed = (_cur$params = cur.params) === null || _cur$params === void 0 ? void 0 : _cur$params.speed) !== null && _cur$params$speed !== void 0 ? _cur$params$speed : 0);
        }, 0);
        return formatSize(totalSpeedInByte, {
          keep3DigitsMax: true,
          alternativeDefaultSizeMap: 'speed'
        }) + '/s';
      } else if (haveTaskPaused.value) {
        return '暂停中';
      } else {
        return '无任务';
      }
    });
    const {
      statClickFlow,
      statShowFlow,
      statClickBird,
      statShowBird
    } = useFlowStat();
    // const totalSpeed = ref(1024*1024*1024*10)
    const isFlowHidden = computed(() => {
      const isVip = Boolean(store.getters.isVip);
      return !isVip || !isManualClickBird.value;
    });
    const isGoldBeanEnabled = computed(() => {
      var _deviceStore$currentD;
      return !((_deviceStore$currentD = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD !== void 0 && _deviceStore$currentD.util.hasLabel('withGoldbean'));
    });
    const isGoldBeanHidden = computed(() => {
      return isGoldBeanEnabled.value || !isManualClickBird.value;
    });
    const whichBird = computed(() => {
      var _deviceStore$currentD2;
      if (!isGoldBeanEnabled.value && ((_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 || (_deviceStore$currentD2 = _deviceStore$currentD2.goldBeanManager.config) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.status) === 'running') {
        return BirdGrowing;
      } else if (isSpeedShow.value) {
        return BirdAwake;
      } else {
        return BirdSleep;
      }
    });
    /**
     * 整个小鸟的dom元素
     */
    const bird = ref(null);
    /**
     * 可点击的流量区域
     */
    const flowArea = ref(null);
    /**
     * 可点击的金豆区域
     */
    const beanArea = ref(null);
    /**
     * 前一次拖动结束后的X坐标
     */
    const lastX = ref(0);
    /**
     * 前一次拖动结束后的Y坐标
     */
    const lastY = ref(0);
    /**
     * 拖动开始时的X坐标
     */
    const startX = ref(0);
    /**
     * 拖动开始时的Y坐标
     */
    const startY = ref(0);
    /**
     * 当前拖动离起点的X偏移量
     */
    const diffX = ref(0);
    /**
     * 当前拖动离起点的Y偏移量
     */
    const diffY = ref(0);
    /**
     * 是否在拖动后，吸附到屏幕边缘的过程中
     */
    const isAttaching = ref(false);
    /**
     * 当前吸附到屏幕左侧还是右侧
     */
    const attachSide = ref('left');
    /**
     * 本次拖动后，吸附到屏幕左侧还是右侧
     */
    const nextAttachSide = ref('right');
    /**
     * 拖动开始的时间戳
     */
    let touchStartTimestamp = 0;
    /**
     * touchstart 到 touchend 中间是否有 touchmove事件触发
     */
    const isDragMoveCalled = ref(false);
    /**
     * 禁用transition
     */
    let noTransition = ref(false);
    let dragStartTarget = null;
    let autoCloseTimer = null;
    const userInfo = ref(null);
    /**
     * toggle展示剩余流量
     */
    const toggleFlow = async () => {
      const isVip = Boolean(store.getters.isVip);
      statClickBird(isVip);
      isManualClickBird.value = !isManualClickBird.value;
      if (isManualClickBird.value) {
        var _deviceStore$currentD3;
        statShowFlow((_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.goldBeanManager.beans);
        // 展开3秒后自动关闭
        autoCloseTimer = window.setTimeout(() => {
          isManualClickBird.value = false;
        }, 3000);
      } else {
        // 关闭时清除自动关闭定时器
        if (autoCloseTimer) {
          window.clearTimeout(autoCloseTimer);
          autoCloseTimer = null;
        }
      }
    };
    /**
     * 是否正在拖动中
     */
    const isDragging = ref(false);
    let dragMoveCallCount = 0;
    const unifyClientXY = e => {
      if (e.touches) {
        return {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY
        };
      }
      return {
        x: e.clientX,
        y: e.clientY
      };
    };
    /**
     * 拖动回调
     */
    const onDragMove = e => {
      // 防止拖动穿透到页面上
      e.stopPropagation();
      if (isDragging.value) {
        if (dragMoveCallCount > DRAG_MOVE_THRESHOLD && !isDragMoveCalled.value) {
          isDragMoveCalled.value = true;
        } else if (!isDragMoveCalled.value) {
          dragMoveCallCount++;
        }
        const {
          x,
          y
        } = unifyClientXY(e);
        // 计算偏移量
        diffX.value = x - startX.value + lastX.value;
        diffY.value = y - startY.value + lastY.value;
        // 如果超过屏幕中线，则吸附到对侧
        if (x > window.innerWidth / 2) {
          nextAttachSide.value = 'right';
        } else {
          nextAttachSide.value = 'left';
        }
        // console.log('onDragMove', e.touches[0].clientX - startX.value!, e.touches[0].clientY - startY.value!, lastX.value, lastY.value)
      }
    };

    const MIN_DIFF_Y = -document.body.clientHeight + 300;
    /**
     * 拖拽结束事件
     */
    const onDragEnd = e => {
      const dragEndReset = () => {
        // 状态reset
        startX.value = 0;
        startY.value = 0;
        touchStartTimestamp = 0;
        document.removeEventListener('touchmove', onDragMove);
        document.removeEventListener('mousemove', onDragMove);
        document.removeEventListener('touchend', onDragEnd);
        document.removeEventListener('mouseup', onDragEnd);
      };
      e.preventDefault();
      e.stopPropagation();
      isDragging.value = false;
      // 因为对touchstart做了preventDefault，所以要自己处理点击事件。
      // 触发touchstart 300ms内触发touchend，且touchmove没有调用过，视为点击
      if (!isDragMoveCalled.value) {
        if (Date.now() - touchStartTimestamp < 300) {
          var _flowArea$value, _beanArea$value;
          if ((_flowArea$value = flowArea.value) !== null && _flowArea$value !== void 0 && _flowArea$value.contains(dragStartTarget)) {
            statClickFlow();
            openPopHighSpeedFlowPurchase({
              userProfile: userInfo.value
            });
          } else if ((_beanArea$value = beanArea.value) !== null && _beanArea$value !== void 0 && _beanArea$value.contains(dragStartTarget)) {
            var _deviceStore$currentD4;
            const {
              statusRef
            } = useGoldBeanStatStatus();
            const {
              statBeansClick
            } = useGoldBeanStat(stat, (_deviceStore$currentD4 = deviceStore.currentDeviceRef.goldBeanManager) !== null && _deviceStore$currentD4 !== void 0 ? _deviceStore$currentD4 : {}, statusRef);
            statBeansClick();
            openPopGoldBeanInfo({});
          } else {
            toggleFlow();
          }
        } else {
          return;
        }
      } else {
        var _diffX$value, _diffY$value;
        isDragMoveCalled.value = false;
        // 储存最后位置信息
        lastX.value = (_diffX$value = diffX.value) !== null && _diffX$value !== void 0 ? _diffX$value : 0;
        lastY.value = (_diffY$value = diffY.value) !== null && _diffY$value !== void 0 ? _diffY$value : 0;
        /**
         * 开始吸附
         */
        isAttaching.value = true;
        /**
         * X轴吸附
         */
        if (bird.value && attachSide.value !== nextAttachSide.value) {
          if (nextAttachSide.value === 'left') {
            diffX.value = -(window.innerWidth - bird.value.clientWidth);
          } else {
            diffX.value = window.innerWidth - bird.value.clientWidth;
          }
          /**
           * Y轴吸附
           */
          if (lastY.value > MAX_DIFF_Y) {
            lastY.value = MAX_DIFF_Y;
            diffY.value = MAX_DIFF_Y;
          } else if (lastY.value < MIN_DIFF_Y) {
            lastY.value = MIN_DIFF_Y;
            diffY.value = MIN_DIFF_Y;
          }
          window.setTimeout(() => {
            isAttaching.value = false;
            noTransition.value = true;
            requestAnimationFrame(() => {
              diffX.value = 0;
              lastX.value = 0;
              attachSide.value = nextAttachSide.value;
              requestAnimationFrame(() => {
                noTransition.value = false;
              });
            });
          }, 300);
        } else {
          diffX.value = 0;
          lastX.value = 0;
          /**
           * Y轴吸附
           */
          if (lastY.value > MAX_DIFF_Y) {
            lastY.value = MAX_DIFF_Y;
            diffY.value = MAX_DIFF_Y;
          } else if (lastY.value < MIN_DIFF_Y) {
            lastY.value = MIN_DIFF_Y;
            diffY.value = MIN_DIFF_Y;
          }
          window.setTimeout(() => {
            isAttaching.value = false;
          }, 300);
        }
      }
      dragEndReset();
    };
    let startPointToBirdBottom = 0;
    const onDragStart = e => {
      e.preventDefault();
      touchStartTimestamp = Date.now();
      e.stopPropagation();
      isDragging.value = true;
      const {
        x,
        y
      } = unifyClientXY(e);
      startX.value = x;
      startY.value = y;
      if (bird.value) {
        startPointToBirdBottom = startY.value - (bird.value.getClientRects()[0].y + bird.value.clientHeight);
      }
      dragStartTarget = e.target;
      isDragMoveCalled.value = false;
      dragMoveCallCount = 0;
      // console.log('onDragStart', startX.value, startY.value, lastX.value, lastY.value, diffX.value, diffY.value)
      document.addEventListener('touchmove', onDragMove);
      document.addEventListener('mousemove', onDragMove);
      document.addEventListener('touchend', onDragEnd);
      document.addEventListener('mouseup', onDragEnd);
    };
    const userStore = useUserStore();
    const initBirdData = async () => {
      var _deviceStore$currentD5, _deviceStore$currentD6;
      await deviceStore.untilDeviceReady();
      (_deviceStore$currentD5 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD5 === void 0 ? void 0 : _deviceStore$currentD5.flow.startPolling();
      if (!userStore.hasInit) {
        await userStore.getUser();
      }
      if ((_deviceStore$currentD6 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD6 !== void 0 && _deviceStore$currentD6.util.hasLabel('withGoldbean')) {
        var _deviceStore$currentD7;
        (_deviceStore$currentD7 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD7 === void 0 ? void 0 : _deviceStore$currentD7.goldBeanManager.init(userStore.userID);
      }
      userInfo.value = userStore.user;
    };
    watch(() => {
      var _deviceStore$currentD8;
      return (_deviceStore$currentD8 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD8 === void 0 || (_deviceStore$currentD8 = _deviceStore$currentD8.runnerTaskRef.params) === null || _deviceStore$currentD8 === void 0 ? void 0 : _deviceStore$currentD8.target;
    }, async val => {
      if (val) {
        initBirdData();
      }
    });
    onMounted(async () => {
      try {
        statShowBird();
        initBirdData();
      } catch (error) {
        console.error(error);
      }
    });
    return (_ctx, _cache) => {
      var _unref$currentDeviceR, _unref$currentDeviceR2, _unref$currentDeviceR3;
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'floating-bird': true,
          'is-attaching': isAttaching.value,
          'is-dragging': isDragMoveCalled.value,
          'attach-to-left': attachSide.value === 'left',
          'attach-to-right': attachSide.value === 'right',
          'no-transition': _unref(noTransition)
        }),
        draggable: "false",
        ref_key: "bird",
        ref: bird,
        style: _normalizeStyle({
          'transform': `translate(${diffX.value}px, ${diffY.value}px)`
        }),
        onTouchstart: onDragStart,
        onMousedown: onDragStart
      }, [_createElementVNode("img", {
        class: "bird-img",
        src: whichBird.value,
        draggable: "false"
      }, null, 8, _hoisted_1), _createElementVNode("div", {
        class: _normalizeClass({
          'bird-box': true,
          'is-transparent': !isSpeedShow.value && isFlowHidden.value
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'column': true,
          'is-hidden': !isSpeedShow.value && isFlowHidden.value,
          'hide-padding-right': isFlowHidden.value && isGoldBeanHidden.value
        })
      }, [_createElementVNode("div", _hoisted_2, _toDisplayString(totalSpeed.value), 1), _hoisted_3], 2), _createElementVNode("div", {
        class: _normalizeClass({
          'column': true,
          'is-hidden': isFlowHidden.value,
          'hide-padding-right': isGoldBeanHidden.value
        }),
        ref_key: "flowArea",
        ref: flowArea
      }, [_createElementVNode("div", _hoisted_4, _toDisplayString((_unref$currentDeviceR = _unref(deviceStore).currentDeviceRef) === null || _unref$currentDeviceR === void 0 ? void 0 : _unref$currentDeviceR.flow.remainFlow), 1), _hoisted_5], 2), _createElementVNode("div", {
        class: _normalizeClass({
          'column': true,
          'is-hidden': isGoldBeanHidden.value,
          'hide-padding-right': true
        }),
        ref_key: "beanArea",
        ref: beanArea
      }, [_createElementVNode("div", _hoisted_6, _toDisplayString((_unref$currentDeviceR2 = (_unref$currentDeviceR3 = _unref(deviceStore).currentDeviceRef) === null || _unref$currentDeviceR3 === void 0 ? void 0 : _unref$currentDeviceR3.goldBeanManager.beans) !== null && _unref$currentDeviceR2 !== void 0 ? _unref$currentDeviceR2 : 0), 1), _hoisted_7], 2)], 2)], 38);
    };
  }
});